import React from "react";

const badges = [
  "Since 2015", "50,000+ Players", "650+ Games", "Instant Withdrawal",
  "5% Welcome Bonus", "10% Loss Commission", "24x7 Support", "UPI · Bank · USDT",
  "SSL Secure", "2-Min Activation",
];

const TrustStrip = () => {
  const row = [...badges, ...badges];
  return (
    <section className="py-6 bg-[#00ff87] overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((b, i) => (
          <span key={`${b}-${i}`} className="inline-flex items-center gap-3 mx-6 font-display font-bold text-black text-sm uppercase tracking-wide">
            {b}
            <span className="h-1.5 w-1.5 rounded-full bg-black/40" />
          </span>
        ))}
      </div>
    </section>
  );
};

export default TrustStrip;
